import type { ReactNode } from 'react';

import { MenuItem, TextField } from '@mui/material';

import { FieldRow } from './FieldRow';

export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectFieldProps {
  label: ReactNode;
  description?: ReactNode;
  value: string;
  options: SelectOption[];
  onChange: (value: string) => void;
  disabled?: boolean;
  /** Allow clearing to an empty value (renders a leading blank option). */
  allowEmpty?: boolean;
  emptyLabel?: string;
}

/** Labelled single-select dropdown laid out as a settings row. */
export function SelectField({
  label,
  description,
  value,
  options,
  onChange,
  disabled = false,
  allowEmpty = false,
  emptyLabel = '—',
}: SelectFieldProps) {
  return (
    <FieldRow label={label} description={description}>
      <TextField
        select
        size="small"
        fullWidth
        value={value}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
        slotProps={{ htmlInput: { 'aria-label': typeof label === 'string' ? label : undefined } }}
      >
        {allowEmpty ? (
          <MenuItem value="">
            <em>{emptyLabel}</em>
          </MenuItem>
        ) : null}
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </FieldRow>
  );
}
